import { useEffect, useState } from 'react';
import { onSwUpdate, applySwUpdate } from './registerSW';
import './UpdatePrompt.css';

export function UpdatePrompt() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    onSwUpdate(() => setVisible(true));
  }, []);

  if (!visible) return null;

  return (
    <div className="update-prompt" role="alert">
      <span>New version available</span>
      <button
        type="button"
        className="update-prompt__btn"
        onClick={() => {
          void applySwUpdate();
        }}
      >
        Reload
      </button>
    </div>
  );
}
